import {DefaultContext} from '../../utils/types';
import React from 'react';
import {State} from '../types/SubstituteItemDetails';

export const initialState: State = {
  item: undefined,
  buyersForItem: [],
  reasonsForDropping: [],
  itemNotes: '',
  itemLocationInformation: undefined,
  constants: undefined,
  hasAnyBuyerInstructions: false,
  orderItemIds: [],
  isfoundAt: false,
};

const defaultVal: DefaultContext<State> = {
  state: initialState,
  dispatch: null,
};

export const SubstituteItemDetailsContext = React.createContext(defaultVal);
